function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import { formNewLaneEventPayload } from '../../../eventing/newLaneEventPayload';
import { formExposureEventPayload } from '../../../eventing/exposureEventPayload';
import { CLICKSTREAM_EVENT_TYPE } from '../../../eventing/clickStreamEventSchema';
import { defaultOnsiteMessageEventPropTypes, onsiteMessageEventPropTypes } from './OnsiteMessageEventingTypes';
import { NBANewLaneEvent } from '../../../eventing/NBANewLaneEvent';
import { NBA_CLICKSTREAM_EVENT_TYPE } from '../../../eventing/nbaClickstreamEventSchema';
import { formNBANewLaneEventPayload } from '../../../eventing/nbaNewLaneEventPayload';
import { ClickstreamEvent } from '../../../eventing/ClickstreamEvent';
export var useOnsiteMessagingClickstreamImpressionEvent = function useOnsiteMessagingClickstreamImpressionEvent(_ref) {
  var newLaneEventData = _ref.newLaneEventData,
      additionalClickStreamData = _ref.additionalClickStreamData,
      _ref$signalForTrigger = _ref.signalForTriggerTracking,
      signalForTriggerTracking = _ref$signalForTrigger === void 0 ? true : _ref$signalForTrigger;

  // useInView docs: https://www.npmjs.com/package/react-intersection-observer
  var _useInView = useInView({
    threshold: 0,
    triggerOnce: true,
    skip: typeof window === 'undefined' || typeof window.IntersectionObserver === 'undefined'
  }),
      _useInView2 = _slicedToArray(_useInView, 2),
      ref = _useInView2[0],
      inView = _useInView2[1];

  useEffect(function () {
    var clickstreamImpressionPayload = formNewLaneEventPayload(CLICKSTREAM_EVENT_TYPE.IMPRESSION, newLaneEventData, additionalClickStreamData);
    var clickstreamExposurePayload = formExposureEventPayload(newLaneEventData);

    if (inView && signalForTriggerTracking) {
      ClickstreamEvent(clickstreamImpressionPayload);
      ClickstreamEvent(clickstreamExposurePayload);

      if ((newLaneEventData === null || newLaneEventData === void 0 ? void 0 : newLaneEventData.isNbaProcessed) === true) {
        NBANewLaneEvent(formNBANewLaneEventPayload(NBA_CLICKSTREAM_EVENT_TYPE.IMPRESSION, newLaneEventData, ''));
      }
    } // eslint-disable-next-line zillow/react-hooks/exhaustive-deps

  }, [inView]);
  return ref;
};
useOnsiteMessagingClickstreamImpressionEvent.propTypes = onsiteMessageEventPropTypes;
useOnsiteMessagingClickstreamImpressionEvent.defaultProps = defaultOnsiteMessageEventPropTypes;